module.exports = __webpack_public_path__ + "img/usa-liver-cancer-male.031816d9.png";